"use client";

import { useState } from "react";
import { ActionButton } from "./progress-ui";

/** Wobbling pig; on a successful crack it shakes and throws a handful of coins. */
export default function PiggyCrack({ action, label, can }: { action: () => Promise<{ ok?: string; error?: string }>; label: string; can: boolean }) {
  const [burst, setBurst] = useState(0);
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        <svg key={burst} viewBox="0 0 120 100" className="piggy" data-crack={burst ? "" : undefined} aria-hidden>
          <ellipse cx="58" cy="56" rx="42" ry="32" fill="currentColor" />
          <circle cx="98" cy="50" r="14" fill="currentColor" />
          <ellipse cx="104" cy="52" rx="7" ry="6" fill="#e07a98" />
          <circle cx="102" cy="51" r="1.4" fill="#7a2a43" /><circle cx="106.5" cy="51" r="1.4" fill="#7a2a43" />
          <circle cx="90" cy="42" r="2.4" fill="#2a1820" />
          <path d="M84 26l8 12-12-2z" fill="#e07a98" />
          <rect x="30" y="80" width="10" height="14" rx="3" fill="#e07a98" /><rect x="70" y="80" width="10" height="14" rx="3" fill="#e07a98" />
          <rect x="46" y="26" width="22" height="5" rx="2.5" fill="#7a2a43" />
          <path d="M16 54c-8-2-8-10-2-10" stroke="#e07a98" strokeWidth="3" fill="none" strokeLinecap="round" />
        </svg>
        {burst > 0 && Array.from({ length: 10 }, (_, k) => {
          const a = (k / 10) * Math.PI * 2;
          return <span key={`${burst}-${k}`} className="coin-burst" style={{ "--x": `${Math.cos(a) * 90}px`, "--y": `${Math.sin(a) * 70 - 30}px`, animationDelay: `${k * 25}ms` } as React.CSSProperties} />;
        })}
      </div>
      <ActionButton action={action} label={label} disabled={!can} className="btn btn-accent h-12 min-w-48 px-6 text-sm" onOk={() => setBurst((b) => b + 1)} />
    </div>
  );
}
